module.exports = __webpack_public_path__ + "img/barcelo-kids.dc062c8c.jpg";